import { Component, OnDestroy, OnInit } from '@angular/core';
import { ESignatureType } from '@literax/enums/document.enum';
import {
  SignRequests,
  XmlValidationResponse,
} from '@literax/modules/validator/validator.interfaces';
import { IAppState } from '@literax/store';
import { Store, select } from '@ngrx/store';

import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'literax-xml-validation-participants',
  templateUrl: './xml-validation-participants.component.html',
  styleUrls: ['./xml-validation-participants.component.scss'],
})
export class XmlValidationParticipantsComponent implements OnInit, OnDestroy {
  document: XmlValidationResponse;
  participants: SignRequests;
  signingMethods = ESignatureType
  signingMethod: any;
  constructor(private store: Store<IAppState>) {}

  ngOnInit() {
    this.store
      .pipe(select((state) => state.validator.XMLValidatedDocument))
      .subscribe((document) => {
        this.document = document;
        this.participants = document?.signRequests;
        this.signingMethod = document?.signingConfiguration?.signingMethod
      });
  }

  ngOnDestroy() {}
}
